export const breakpoints = {
  mobile: '600px',
  tablet: '768px',
  desktop: '1024px',
  wide: '1260px',
  xl: '1400px',
} as const;

// these values subtract 304px from the viewport breakpoints (combined width of the app chrome basically)
export const containerBreakpoints = {
  mobile: '296px',
  tablet: '464px',
  desktop: '720px',
  wide: '956px',
  xl: '1096px',
} as const;

export type Breakpoint = keyof typeof breakpoints;
export type ContainerBreakpoint = keyof typeof containerBreakpoints;
